import { AccessToken, AccessTokenPayload, AccessTokenType, NewAccessToken } from '@dev/ee-api/ee-api-models';
import { AxiosPromise } from 'axios';
import { request } from './request';

export const loadAccessTokens = (): AxiosPromise<AccessToken[]> => {
    const { Security } = request();
    return Security.securityAccesstokensGet();
};
export const createAccessToken = (accessToken: AccessTokenPayload): AxiosPromise<NewAccessToken> => {
    const { Security } = request();
    return Security.securityAccesstokensPost(accessToken);
};
export const deleteAccessToken = (token: { name: string; type: AccessTokenType }): AxiosPromise<void> => {
    const { Security } = request();
    return Security.securityAccesstokensByNameDelete(token.name, token.type);
};
export const updateAccessToken = (toUpdate: { name: string; body: AccessTokenPayload }): AxiosPromise<AccessToken> => {
    const { Security } = request();
    return Security.securityAccesstokensByNamePut(toUpdate.name, toUpdate.body);
};
export const changeAccessToken = (tokenName: string, type: AccessTokenType): AxiosPromise<string> => {
    const { Security } = request();
    return Security.securityAccesstokensByNameTokenPatch(tokenName, type);
};
